export enum HeliosThemes {
  Web = 'web',
  BusinessProducts = 'business-products'
}
